import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

type Props = {
  background?: string
  className?: string
}

export const StickyBar = ({
  background = 'bg-black/90',
  className,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(
        'z-sticky sticky bottom-0 left-0 h-24 w-full min-w-[calc(1080px+40px*2)] py-6',
        background,
      )}
    >
      <div className="mx-auto flex h-fit w-fit">
        <div
          className={cn(
            'mx-10 flex w-[1080px] flex-shrink-0 justify-end',
            className,
          )}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
